class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    // Sin scroll automático: la página se queda donde está al enfocar el campo.
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Al entrar en /search el foco va directo al campo, con el cursor al final del texto.
(function () {
  function focusInput() {
    var input = document.getElementById('Search-In-Template');
    if (!input) return;
    input.focus({ preventScroll: true });
    var length = input.value.length;
    if (input.setSelectionRange) input.setSelectionRange(length, length);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusInput);
  else focusInput();
})();
